const EmployeeListReducer = (state = { loader: false, result: [], error: null }, action) => {
    switch (action.type) {
      case 'MANAGER_LIST_BEGINS':
        return {
          loader: true,
          result: state.result,
          error: null,
        };
      case 'MANAGER_LIST_SUCCESS':
        
        return {
          loader: false,
          result: action.payload,
          error: null,
        };
      case 'MANAGER_LIST_FAILURE':
        return {
          loader: false,
          result: {},
          error: action.payload,
        };
    
      case 'MANAGER_LIST_RESET':
        return {
          loader: false,
          result: {},
          error: null,
        };
      default:
        return state;
    }
  };
  
  export default EmployeeListReducer;